import "./root-layout.css";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useRootContext } from "../../hooks/useRootContext";
import Navigation from "../../components/navigation/Navigation";
import Faq from "../../components/faq/Faq";
import ContactForm from "../../components/contact-form/ContactForm";
import Foot from "../../components/foot/Foot";
import FooterPartners from "../../components/footer-partners/FooterPartners";
import ServiceCategories from "../../components/service-categories/ServiceCategories";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Slide from "@mui/material/Slide";

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element,
  window: PropTypes.func,
};

function RootLayout(props) {
  const { isNavModalOpen, setIsNavMenuOpen, navHeight, isRouteLoading } = useRootContext();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className={`root-layout animate__animated animate__fadeIn animate__faster ${isRouteLoading && "background-primary"}`}>
      {/* Navigation */}
      <HideOnScroll {...props}>
        <AppBar>
          <Navigation />
        </AppBar>
      </HideOnScroll>

      {/* Outlet */}
      <main
        role="main"
        className={isNavModalOpen ? "outlet pointer-none" : "outlet "}
        style={{ paddingTop: `${navHeight}px` }}
        onClick={() => setIsNavMenuOpen(false)}
      >
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="footer">
        {/* Footer Partners */}
        {location.pathname.split("/")[1] === "services" ||
          location.pathname.split("/")[1] === "our-work" ? (
          <FooterPartners />
        ) : null}

        {/* FAQ */}
        <Faq
          contactUs={
            location.pathname.split("/")[1] === "contact-us" ? true : false
          }
        />

        {/* Contact Form */}
        {location.pathname.split("/")[1] === "contact-us" ? null : (
          <ContactForm color="dark" phoneNumber={false} />
        )}

        {/* Foot Our Services */}
        {location.pathname.split("/")[1] === "contact-us" ? (
          <div className="foot-our-services-section">
            <div className="foot-our-services-section-header">
              <h1>
                <span className="bold">Our</span> Services
              </h1>
              <div className="foot-our-services-section-header-border"></div>
            </div>

            <div className="foot-our-services-categories">
              <ServiceCategories />
            </div>
          </div>
        ) : null}

        {/* Foot */}
        <Foot />
      </footer>
    </div>
  );
}

export default RootLayout;
